import { Box, Typography } from '@mui/material';
import React from 'react';

export const AnayteCardText = ({
  title,
  text,
  items,
}: {
  title: string;
  text?: string;
  items?: string[];
}): JSX.Element => {
  return (
    <Box display="flex" flexDirection="column">
      <Typography fontSize={14} variant="medium" sx={{ mt: 2, mb: 1 }}>
        {title}
      </Typography>
      {items && items.length > 0 && (
        <>
          {items?.map((item: string, index: number) => (
            <li key={`${index}-${item}`}>
              <Typography fontSize={14} variant="light" sx={{ opacity: 0.8 }}>
                {item}
              </Typography>
            </li>
          ))}
        </>
      )}
      {text && (
        <Typography fontSize={14} variant="light" sx={{ opacity: 0.8 }}>
          {text}
        </Typography>
      )}
    </Box>
  );
};
